// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timelineView_x9DOZ {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr auto;
  height: 100%;
  container-type: size;
}

.timelineViewContent_u4JX4 {
  display: grid;
  font-size: calc(var(--width) / var(--height));
  grid-template-columns: repeat(var(--num-cols), 1fr);
  grid-template-rows: minmax(250px,calc(50cqh - 24px));
  gap: var(--size-padLarge);
  padding: var(--size-padLarge);
  height: 100%;
}

.timelineViewContent_u4JX4 > * {
  overflow: hidden;
}

.sizingParentShim_NuGkQ {
  height: 100%;
  width: 100%;
  container-type: size;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/api-ui-rsrc-management/lib/dataViewers/timeline/TimelineView.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,0BAA0B;EAC1B,4BAA4B;EAC5B,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,6CAA6C;EAC7C,mDAAmD;EACnD,oDAAoD;EACpD,yBAAyB;EACzB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,oBAAoB;AACtB","sourcesContent":[".timelineView {\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr auto;\n  height: 100%;\n  container-type: size;\n}\n\n.timelineViewContent {\n  display: grid;\n  font-size: calc(var(--width) / var(--height));\n  grid-template-columns: repeat(var(--num-cols), 1fr);\n  grid-template-rows: minmax(250px,calc(50cqh - 24px));\n  gap: var(--size-padLarge);\n  padding: var(--size-padLarge);\n  height: 100%;\n}\n\n.timelineViewContent > * {\n  overflow: hidden;\n}\n\n.sizingParentShim {\n  height: 100%;\n  width: 100%;\n  container-type: size;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"timelineView": `timelineView_x9DOZ`,
	"timelineViewContent": `timelineViewContent_u4JX4`,
	"sizingParentShim": `sizingParentShim_NuGkQ`
};
export default ___CSS_LOADER_EXPORT___;
